module.exports = __webpack_public_path__ + "img/warning.109eade7.svg";